var app = require('../index');

app.fn('faq.toggleAnswer', function(e, el) {
	var questionModel = e.at(':question');
	questionModel.set('showAnswer', !e.get(':question.showAnswer'));
});